import { useState } from 'react';
import { RiskAction } from '../../models';
import { apiClient, apiErrorMessage } from '../../utils';
import { Button, Form, Input, Space } from 'antd';
import { useForm } from 'antd/lib/form/Form';

export function RiskActionEvaluationForm(props: { riskAction?: RiskAction; onSaved?: () => void }) {
  const [form] = useForm();
  const [acceptLoading, setAcceptLoading] = useState(false);
  const [rejectLoading, setRejectLoading] = useState(false);

  const onFinish = (isAccepted: boolean) => {
    const values = form.getFieldsValue();
    const body = { ...values, result: isAccepted ? 'ACCEPTED' : 'REJECTED' };

    isAccepted ? setAcceptLoading(true) : setRejectLoading(true);

    apiClient
      .patch(`risk-actions/${props.riskAction?.id}/evaluation`, body)
      .then(() => {
        if (props.onSaved) {
          props.onSaved();
        }
      })
      .catch((reason: any) => {
        apiErrorMessage(reason);
      })
      .finally(() => {
        setAcceptLoading(false);
        setRejectLoading(false);
      });
  };

  return (
    <Form layout="vertical" name="basic" form={form}>
      <Form.Item
        label="Değerlendirme açıklaması"
        rules={[
          {
            required: true,
            message: 'Zorunlu alan',
          },
        ]}
        name="evaluationMessage"
      >
        <Input.TextArea />
      </Form.Item>

      <Form.Item style={{ marginTop: '2rem', textAlign: 'center' }}>
        <Space>
          <Button type="primary" onClick={() => onFinish(true)} loading={acceptLoading} disabled={rejectLoading}>
            Onayla
          </Button>
          <Button type="default" onClick={() => onFinish(false)} loading={rejectLoading} disabled={acceptLoading}>
            Reddet
          </Button>
        </Space>
      </Form.Item>
    </Form>
  );
}
